import { FAQ } from 'models/faq';
import {Agent, request} from './base';

export class FAQAgent extends Agent<FAQ> {
    constructor() {
        super(FAQ, '/faq');
    }

    sync = async () => {
        await request.post('/faq/sync', {});
    };
}
